import { render, staticRenderFns } from "./UserEventComponent.vue?vue&type=template&id=d80c5772&scoped=true&"
import script from "./UserEventComponent.vue?vue&type=script&lang=js&"
export * from "./UserEventComponent.vue?vue&type=script&lang=js&"
import style0 from "./UserEventComponent.vue?vue&type=style&index=0&id=d80c5772&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80c5772",
  null
  
)

export default component.exports